window.addEventListener('DOMContentLoaded', () => {
  $('.copy_content').on('click', (event) => {
    $('#article_content').prepend($('#article_title'));
    utils.copyToClipboard('article_content');
    $('#article_container').prepend($('#article_title'));

    event.preventDefault();
  })
})
